import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { VentasComponent } from '../informes/ventas/ventas.component';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { NothingComponent } from '../objects/nothing/nothing.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-lista-saldos',
  templateUrl: './lista-saldos.component.html',
  styleUrls: ['./lista-saldos.component.css']
})
export class ListaSaldosComponent implements OnInit {

  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public usuario: Usuario = new Usuario();
  public rangofechas: RangoFechas = new RangoFechas();
  public tipoinforme = 0;

  public idsucursal: number = 1;
  public funcion: Function = null;
  public isShow: boolean = false;
  public pagina: number = 0;
  public modal = "modal-lg";
  public zindex: number = 10000;
  public listaarticulos: any[] = [];
  public alertType: AlertType = new AlertType();
  public sumatotal: number = 0;
  public empresa: any;
  public pagventas: any = 0;
  public today = new Date();
  public fechaHoraActual: Date = new Date();
  public fecha: string = new Date().toLocaleDateString('en-CA');
  constructor(private data: DataService, private datePipe: DatePipe, private reportViewer: ReportViewerService) { }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.idsucursal = parseInt(this.data.getSucursalId())
    //this.getEmpresa()
    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.info.hide();
    }, 10);
  }

  close() {
    this.btnclose.nativeElement.click();
  }

  getEmpresa() {
    this.data.GetSimple(this.data.api.empresa).subscribe(r => {
      console.log("Empresa:", r);
      this.empresa = r[0];
    }), (error) => {
      console.log(error);

    };
  }

  // GetListSaldos(callback: () => void) {
  //   this.data.GetSimple(this.data.api.articulos).subscribe(
  //     (data) => {
  //       this.listaarticulos = data;
  //       console.log("Lista de saldos obtenida", this.listaarticulos);

  //       setTimeout(() => {
  //         callback(); // Se ejecuta después de un pequeño delay
  //       }, 300); // Pequeño tiempo de espera para renderizar los datos
  //     },
  //     (error) => {
  //       console.error("Error obteniendo saldos", error);
  //     }
  //   );
  // }

  GetListSaldos(callback: () => void) {
    this.data.GetSimple(`saldos_detallado/${this.idsucursal}/?fecha=${this.fecha}`).subscribe(
      (r: any) => { this.listaarticulos = r.data; setTimeout(() => callback(), 100); },
      (error: any) => console.error('Error obteniendo saldos', error)
    );
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }


  ImprimirSaldos() {
    this.getEmpresa();
    this.GetListSaldos(() => {
      // this.printerListaSaldos(); // Se ejecuta solo después de obtener la lista
      const blob = this.printerListaSaldos();
      // Mostrar en el modal reutilizable
      if (blob) {
        const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
        this.reportViewer.mostrarPDF(
          blob,
          'Lista de saldos',
          `lista_saldos_${fecha}.pdf`
        );
      }
    });
  }

  printerListaSaldos1(): Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'LISTA DE SALDOS', x: 80, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      //doc.text(`Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
      // if (this.empresa.logo) {
      //   doc.addImage(this.empresa.logo, 'PNG', 10, 8, 37.5, 7.5);
      // } // Añade tu imagen  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['Codigo', 'Nombre', 'Unidad', 'Marca', 'Modelo', 'Color', 'Saldo', 'Tipo'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#saldos tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        9: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 9,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 2,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(10);

        doc.text('Codigo', data.settings.margin.left, data.cursor.y);
        doc.text('Nombre', data.settings.margin.left, data.cursor.y);
        doc.text('Unidad', data.settings.margin.left, data.cursor.y);
        doc.text('Marca', data.settings.margin.left, data.cursor.y);
        doc.text('Modelo', data.settings.margin.left, data.cursor.y);
        doc.text('Color', data.settings.margin.left, data.cursor.y);
        doc.text('Saldo', data.settings.margin.left, data.cursor.y);
        doc.text('Tipo', data.settings.margin.left, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    // doc.autoPrint({ variant: 'non-conform' });

    // const blob = doc.output('blob');
    // const url = URL.createObjectURL(blob);

    // const iframe = document.createElement('iframe');
    // iframe.style.display = 'none';
    // iframe.src = url;
    // document.body.appendChild(iframe);

    // iframe.onload = () => {
    //   if (iframe.contentWindow) {
    //     iframe.contentWindow.print();
    //   }
    // };
    return doc.output('blob');
    //doc.save('informe.pdf');

  }

  printerListaSaldos(): Blob | null {
    const doc = new jsPDF();  // portrait A4

    const addHeader = () => {
      doc.setFontSize(14);
      doc.text('LISTA DE SALDOS', 75, 20);
      doc.setFontSize(9);
      doc.text(`Fecha: ${this.fecha}   Generado: ${this.formatFecha(this.today, 'dd-MM-yyyy HH:mm')}`, 100, 28);
    };

    const tableRows: any[] = [];
    const tot = { envasado: 0, vacios: 0, articulos: 0, prestamos: 0, saldo: 0 };

    this.listaarticulos.forEach((art: any) => {
      const cn = (art.clase_nombre || '').toUpperCase();
      const saldo = Number(art.saldo || 0);
      const prestamos = Number(art.prestamos || 0);
      const saldoNeto = saldo - prestamos;

      const esEnv = cn.includes('ENVASADO');
      const esVac = cn.includes('VACIO');

      if (esEnv) tot.envasado += saldo;
      else if (esVac) tot.vacios += saldo;
      else tot.articulos += saldo;
      tot.prestamos += prestamos;
      tot.saldo += saldoNeto;

      tableRows.push([
        art.codigo || '',
        art.nombre || '',
        esEnv ? saldo : '-',
        esVac ? saldo : '-',
        (!esEnv && !esVac) ? saldo : '-',
        prestamos || '-',
        saldoNeto,
      ]);
    });

    tableRows.push(['TOTAL', '', tot.envasado, tot.vacios, tot.articulos, tot.prestamos, tot.saldo]);

    (doc as any).autoTable({
      head: [['Código', 'Nombre', 'Envasado', 'Vacíos', 'Artículos', 'Préstamos', 'Saldo']],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10 },
      theme: 'grid',
      columnStyles: {
        0: { halign: 'left', cellWidth: 20 },
        1: { halign: 'left', cellWidth: 65 },
        2: { halign: 'right', cellWidth: 20 },
        3: { halign: 'right', cellWidth: 20 },
        4: { halign: 'right', cellWidth: 20 },
        5: { halign: 'right', cellWidth: 20 },
        6: { halign: 'right', cellWidth: 20 },
      },
      styles: { fontSize: 8, cellPadding: 1.5 },
      headStyles: { fillColor: [200, 200, 200], textColor: [0, 0, 0], fontStyle: 'bold' },
      didParseCell: (data: any) => {
        if (data.row.index === tableRows.length - 1 && data.section === 'body')
          data.cell.styles.fontStyle = 'bold';
      },
      didDrawPage: (data: any) => {
        addHeader();
        doc.text(`Página ${data.pageNumber}`, 180, 15);
      }
    });

    return doc.output('blob');
  }


}
